import { useEffect, useState } from 'react'
import { resolveShellLayoutMode, type ShellLayoutMode } from './shellLayout'

function readViewport(): { width: number; height: number } {
  if (typeof window === 'undefined') return { width: 390, height: 844 }
  return {
    width: window.innerWidth || document.documentElement.clientWidth || 390,
    height: window.innerHeight || document.documentElement.clientHeight || 844
  }
}

/** Tracks PORTRAIT / LANDSCAPE_COMPACT / DESKTOP from the real viewport. */
export function useShellLayoutMode(): ShellLayoutMode {
  const [mode, setMode] = useState<ShellLayoutMode>(() => {
    const { width, height } = readViewport()
    return resolveShellLayoutMode(width, height)
  })

  useEffect(() => {
    const apply = () => {
      const { width, height } = readViewport()
      setMode(resolveShellLayoutMode(width, height))
    }
    apply()
    window.addEventListener('resize', apply)
    window.addEventListener('orientationchange', apply)
    const vv = window.visualViewport
    vv?.addEventListener('resize', apply)
    return () => {
      window.removeEventListener('resize', apply)
      window.removeEventListener('orientationchange', apply)
      vv?.removeEventListener('resize', apply)
    }
  }, [])

  return mode
}
